
import axios from 'axios';
export default class BlogApiService {
    
    static getBlogList() {      
        return axios.get('https://blogs.heyvageneraltrading.com' + '/heyvablogs')
    }
    static getBlogList2() {      
        return axios.get('https://blogs.heyvageneraltrading.com' + '/heyvablogs2')
    }
    static getBlogInfo(url:any) {
        return axios.get('https://blogs.heyvageneraltrading.com' + `/heyvablogs/${url}`)
    }
}